import { render, staticRenderFns } from "./news-page.vue?vue&type=template&id=99756eb4&scoped=true&"
import script from "./news-page.vue?vue&type=script&lang=js&"
export * from "./news-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99756eb4",
  null
  
)

export default component.exports